import React, { FC, useEffect, useMemo, useRef, useState } from "react"
import { useHistory } from "react-router"
import { useRecoilValue } from "recoil"
import { getInventoryInPharmacy, getPharmacyInfoLocal } from "../../api"
import usePharmacy from "../../hooks/pharmacy"
import { PharmacyDetailModel } from "../../models"
import { cheapestProductModel } from "../../models"
import { ProductModel } from "../../models"
import { accountDataState } from "../../recoil/account"
import { debounce, formatPrice } from "../../utils"
import { useAsync } from "../../utils/hooks"
import Loading from "../shared/Loading"
import { ISearchEsProduct, searchEsProduct } from '../../api'
import { getCheapestPriceProduct, readAll, total } from "../../api"

interface IState {
    offset: number,
    skip: number,
    limit: number,
    listProduct: Array<cheapestProductModel>,
    fetched: boolean,
}

interface IProps {
    countUnread?: number;
    setCountUnread: (count: number) => void;
}

const initState: IState = {
    offset: 0,
    skip: 0,
    limit: 20,
    listProduct: [],
    fetched: false,
}

const CheapestPriceProduct: FC<IProps> = React.memo((props) => {
    const { countUnread, setCountUnread } = props

    const history = useHistory()

    const { getCurrentDetailPharmacy } = usePharmacy()
    const getCurrentDetailPharmacyAsync = useAsync<PharmacyDetailModel>(getCurrentDetailPharmacy)
    const getCheapestPriceProductAsync = useAsync(getCheapestPriceProduct)
    const searchProductAsync = useAsync(searchEsProduct)
    const readAllAsync = useAsync(readAll)
    const totalAsync = useAsync(total)

    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN') return accountInfo.doctor.mId
    }, [accountInfo])

    const { pharmacyDetail, pharmacyId } = useMemo(() => {
        return { pharmacyDetail: getCurrentDetailPharmacyAsync.value, pharmacyId: getCurrentDetailPharmacyAsync.value?.pharmacy.mId }
    }, [getCurrentDetailPharmacyAsync.value])

    const [state, setState] = useState<IState>(initState)
    const [totalProduct, setTotalProduct] = useState<number>(0)
    const inputSearch: any = useRef()
    const tableProduct: any = useRef()

    const backToTop = () => {
        if (!tableProduct.current?.scrollTop) return
        tableProduct.current.scrollTop = 0
    }

    useEffect(() => {
        const pharmacyInfo = getPharmacyInfoLocal()
        if (pharmacyInfo) {
            getCurrentDetailPharmacyAsync.execute()
        } else {
            console.error("Not found pharmacy info");
        }
    }, [])

    useEffect(() => {
        getInitData()
    }, [adminId, pharmacyId])

    useEffect(() => {
        totalAsync.execute().then(res => {
            setTotalProduct(res.data.count)
        })
    }, [])

    const updateToFetchingState = () => {
        setState(prev => ({ ...prev, fetched: false }))
    }

    const getInitData = () => {
        if (!pharmacyId) return

        updateToFetchingState()
        getCheapestPriceProductAsync.execute({

            skip: initState.skip,
            limit: initState.limit,

        }).then(res => {
            setState(prev => ({ ...prev, listProduct: res, fetched: true }))
        })
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!state.fetched) {
                return
            }

            try {
                let lpId: string[] = []
                state.listProduct && state.listProduct.map(product => {
                    lpId.push(product.mProductId)
                })
                if (!lpId) return
                let listImage: ProductModel[] = []
                await searchProductAsync.execute(getQuery(lpId)).then(res => {
                    listImage = res.data
                })
                if (!listImage) return
                state.listProduct?.map((item) => {
                    let found = listImage.find(i => i._id == item.mProductId)
                    if (found) {
                        item.imageUrls = found.imageUrls
                    }

                })
                setState(prev => ({ ...prev, listProduct: state.listProduct }))

            } catch (err) {
                console.error("cannot fetch data: ", err);
            }
        }
        fetchData()
    }, [state.fetched])



    const handleChange = debounce((value: string) => {
        backToTop()

        const filter = {
            skip: initState.skip,
            limit: initState.limit,
        }
        totalAsync.execute(getQuerySearch(value).mProductName?.like).then(res => {
            setTotalProduct(res.data.count)
        })
        updateToFetchingState()
        getCheapestPriceProductAsync.execute(
            filter,
            getQuerySearch(value).mProductName?.like
        ).then(res => {
            setState(prev => ({
                ...prev,
                skip: initState.skip,
                limit: initState.limit,
                listProduct: res,
                fetched: true
            }))
        })
    }, 500)


    const getQuerySearch = (value: string) => {
        if (value !== '') {

            value = value.replace(/\s+/g, ' ').trim()

            return {
                mProductName: {
                    like: `%${value}%`
                }
            }
        }
        return {}
    }


    const loadmore = () => {
        if (totalProduct == state.listProduct.length) return

        const filter = {
            skip: state.skip + initState.limit,
            limit: state.limit,
        }
        const search = getQuerySearch(inputSearch?.current?.value).mProductName?.like

        updateToFetchingState()
        getCheapestPriceProductAsync.execute(
            filter,
            search
        ).then(res => {
            setState(prev => ({
                ...prev,
                skip: prev.skip + initState.limit,
                listProduct: [
                    ...prev.listProduct,
                    ...res,
                ],
                fetched: true
            }))
        })
    }

    const getQuery = (listProductId: string[]) => {
        return {
            "_source": ["imageUrls"],
            "query": {
                "bool": {
                    "should":
                        listProductId.map(id => {
                            return {
                                "term": {
                                    "id": id
                                }
                            }
                        })

                }
            },
            "from": 0,
            "size": listProductId.length
        }
    }
    return <>
        <div id="main" style={{
            width: "100%",
            // paddingTop: '65px',
            height: '100vh',
            minHeight: '-webkit-fill-available',
            // display: 'flex',
            // flexDirection: 'column',
        }}
        >
            {
                (getCurrentDetailPharmacyAsync.status == "loading") ?
                    <div className="wrap-loading">
                        <Loading />
                    </div> :
                    <>
                        <div className="container">

                            <div className="form-search my-3">
                                <form id="search">
                                    <input
                                        ref={inputSearch}
                                        onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                        onChange={(e) => {
                                            const { value } = e.target
                                            handleChange(value)
                                        }} type="text" name="search" placeholder="Tìm theo tên thuốc" className="input-search" />
                                    <a
                                        id="btn-search-clear"
                                        onClick={() => {
                                            inputSearch.current.value = ''
                                            handleChange('')
                                        }}
                                    >
                                        <img src="./images/cancel.svg" title="Xóa" className="img-fluid" width={24} alt='' />
                                    </a>
                                    <button type="button" className="btn-search">
                                        <img src="./images/search.svg" title="Tìm kiếm" className="img-fluid" width={24} />
                                    </button>
                                </form>
                            </div>


                        </div>
                        {countUnread !== 0 && <div className="container">
                            Có <span className="txt-orange">{countUnread}</span> sản phẩm đã thay đổi giá thấp nhất
                            <span className="" style={{ float: 'right', color: '#36cd7a', cursor: 'pointer' }}
                                onClick={
                                    () => {
                                        readAllAsync.execute()
                                        setCountUnread(0)
                                        let copyState = { ...state }
                                        copyState.listProduct.map(item => {
                                            item.mPrioritized = false
                                        })
                                        setState(prev => ({
                                            ...prev, listProduct: [
                                                ...copyState.listProduct
                                            ]
                                        }))
                                    }
                                }>Đã xem</span>
                        </div>}
                        {
                            state.listProduct.length === 0 &&
                            <div className="d-flex py-3 justify-content-center align-items-center">
                                <p className="m-0">Không tìm thấy sản phẩm nào</p>
                            </div>
                        }

                        <div className="row mt-2"></div>

                        {
                            state.listProduct.length !== 0 &&
                            <>
                                <div ref={tableProduct} className="table-products" style={{ position: "relative", maxHeight: 'unset' }}>

                                    {
                                        state.listProduct?.map((product: cheapestProductModel) => {
                                            return <div className="pl-3 pr-3 pb-2 border-top" key={product.mId}
                                                style={product.mPrioritized ? { display: 'flex', backgroundColor: '#f2f2f2' } : { display: 'flex' }}
                                                onClick={() => {
                                                    history.push(`/update-product?productId=${product.mProductId}`)
                                                }}
                                            >

                                                <div className="align-item-center mt-2" style={{ flex: '20%' }}>
                                                    <img style={{ objectFit: 'contain', border: '1px solid #ccc', borderRadius: "10px" }} width={80} height={80} src={(product.imageUrls && product.imageUrls[0]) ? product.imageUrls[0] : "./images/default-medicine.png"} />
                                                </div>
                                                <div className="m-2" style={{ flex: '80%' }}>
                                                    <div className="mb-2">
                                                        <strong >{product.mProductName}</strong>
                                                    </div>
                                                    {product.productStats?.length > 0 &&
                                                        <div>
                                                            Giá thấp nhất khu vực
                                                            <span>   {product.productStats?.map(productStarts => {
                                                                return <span key={productStarts.mPackageId}><span className="txt-orange ml-2 mr-2">{`${formatPrice(productStarts.mMinPrice)} đ/${productStarts.mPackageName}`}</span>|</span>
                                                            })}</span>
                                                        </div>}

                                                </div>
                                            </div>
                                        })
                                    }

                                    {
                                        getCheapestPriceProductAsync.status == "loading" &&
                                        <div className="wrap-loading">
                                            <Loading />
                                        </div>
                                    }
                                </div>
                                {
                                    totalProduct != state.listProduct.length &&
                                    <div className="d-flex mt-2 justify-content-center">
                                        <button className="btn p-1 px-2" style={{ fontSize: 13 }} onClick={loadmore}>Xem thêm</button>
                                    </div>
                                }
                                <div className="w-100 d-flex py-3 justify-content-center align-items-center">
                                    {/* {console.log(state.total, state.listProduct.length)} */}
                                    <b className="m-0">Tổng số {totalProduct} sản phẩm</b>
                                </div>
                            </>
                        }
                    </>
            }
        </div>
    </>
})

export default CheapestPriceProduct